import dashboard from './Admin';
import User from './User';
// import utilities from './utilities';
// import other from './other';

// ==============================|| MENU ITEMS ||============================== //

export const menuItems_admin = {
  items: [dashboard]
};

export const menuItems_user = {
  items: [User]
};



